// fiexed menu scroll

function addClass(selector, myClass) {
  // get all elements that match our selector
  elements = document.querySelectorAll(selector);
  // add class to all chosen elements
  for (let i = 0; i < elements.length; i++) {
    elements[i].classList.add(myClass);
  }
}

function removeClass(selector, myClass) {
  // get all elements that match our selector
  elements = document.querySelectorAll(selector);
  // remove class from all chosen elements
  for (let i = 0; i < elements.length; i++) {
    elements[i].classList.remove(myClass);
  }
}

function autoHideHeader() {
  const currentTop = window.scrollY;
  if (currentTop > 0) {
    addClass('.cd-auto-hide-header', 'dark-color');
  } else {
    removeClass('.cd-auto-hide-header', 'dark-color');
  }
  belowNavHeroContent.length > 0 ? checkStickyNavigation(currentTop) // secondary navigation below intro
    : checkSimpleNavigation(currentTop);
  previousTop = currentTop;
  scrolling = false;
}

function checkSimpleNavigation(currentTop) {
  // there's no secondary nav or secondary nav is below primary nav
  if (previousTop - currentTop > scrollDelta) {
    // if scrolling up...
    removeClass('.cd-auto-hide-header', 'is-hidden');
  } else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
    // if scrolling down...
    addClass('.cd-auto-hide-header', 'is-hidden');
  }
}

const mainHeader = document.getElementsByClassName('cd-auto-hide-header');
belowNavHeroContent = document.getElementsByClassName('sub-nav-hero');
headerHeight = mainHeader.clientHeight;
// set scrolling variables
var scrolling = false;
var previousTop = 0;
const currentTop = 0;
var scrollDelta = 10;
var scrollOffset = 150;
window.addEventListener('scroll', () => {
  if (!scrolling) {
    scrolling = true;
    !window.requestAnimationFrame ? setTimeout(autoHideHeader, 250) : requestAnimationFrame(autoHideHeader);
  }
});
window.onresize = function (event) {
  headerHeight = mainHeader.innerHTML = window.innerHeight;
};

if ($('.pro-car-box')[0]) {
  (function () {
    // Init
    const container = document.getElementById('pro-car-box');
    const inner = document.getElementById('pro-car-box-img');
    // Mouse
    const mouse = {
      _x: 0,
      _y: 0,
      x: 0,
      y: 0,
      updatePosition(event) {
        const e = event || window.event;
        this.x = e.clientX - this._x;
        this.y = (e.clientY - this._y) * -1;
      },
      setOrigin(e) {
        this._x = e.offsetLeft + Math.floor(e.offsetWidth / 2);
        this._y = e.offsetTop + Math.floor(e.offsetHeight / 2);
      },
      show() {
        return `(${this.x}, ${this.y})`;
      },
    };
    // Track the mouse position relative to the center of the container.
    mouse.setOrigin(container);
    //----------------------------------------------------
    let counter = 0;
    const refreshRate = 10;
    const isTimeToUpdate = function () {
      return counter++ % refreshRate === 0;
    };
    //----------------------------------------------------
    const onMouseEnterHandler = function (event) {
      update(event);
    };
    const onMouseLeaveHandler = function () {
      inner.style = '';
    };
    const onMouseMoveHandler = function (event) {
      if (isTimeToUpdate()) {
        update(event);
      }
    };
    //----------------------------------------------------
    var update = function (event) {
      mouse.updatePosition(event);
      updateTransformStyle((mouse.y / inner.offsetHeight / 2).toFixed(2), (mouse.x / inner.offsetWidth / 2).toFixed(2));
    };
    var updateTransformStyle = function (x, y) {
      const style = `rotateX(${x}deg) rotateY(${y}deg)`;
      inner.style.transform = style;
      inner.style.webkitTransform = style;
      inner.style.mozTranform = style;
      inner.style.msTransform = style;
      inner.style.oTransform = style;
    };
    //--------------------------------------------------------
    container.onmousemove = onMouseMoveHandler;
    container.onmouseleave = onMouseLeaveHandler;
    container.onmouseenter = onMouseEnterHandler;
  }());
}
$(document).on('click', 'div.nc-msg.alert button.close', function () {
  $(this).closest('.alert').remove();
});
if ($('.pro-cart').length) {
  $('.pro-edit-button').on('click', function (e) {
    const $self = $(this);
    const $input = $self.siblings('input');
    if ($input.is('[readonly]')) {
      $input.attr('readonly', false);
      $input.focus();
      const temp = $input.val();
      $input.val('');
      $input.val(temp);
    }
  });

  $('.pro-label').on('click', function (e) {
    const $self = $(this);
    const $input = $self.find('input');
    if ($input.is('[readonly]')) {
      $input.attr('readonly', false);
      $input.focus();
      const temp = $input.val();
      $input.val('');
      $input.val(temp);
    }
  });

  $('.pro-input-form').on('focusout', function (e) {
    const $self = $(this);
    $self.attr('readonly', true);
  });
  $('.pro-radio-input').on('change', () => {
    if ($('#pro-person').prop('checked')) {
      $('.pro-calculator-compay-info').addClass('pro-hide-it');
      $('.pro-input-form').prop('required', false);
    } else {
      $('.pro-calculator-compay-info').removeClass('pro-hide-it');
      $('.pro-input-form').prop('required', true);
    }
  });
}

// przeliczanie ceny w kreatorze

function float_format(val) {
  const result = val.toString().split('.');
  return (result[1] > 0) ? val : result[0];
}

const offersBox = document.querySelectorAll('.pro-showcase-box, .pro-showcase-box-extended');

function setPrice() {
  for (const offerBox of offersBox) {
    const $offerBox = $(offerBox);
    const nextYearPrice = $offerBox.find('.next-year-price');
    const priceYear = parseFloat($offerBox.find('.pro-card-price').data('priceYear'));
    const priceYearPln = parseFloat($offerBox.find('.pro-card-price').data('priceYearPln'));
    const $priceSpan = $offerBox.find('span.price');
    const $priceSpanPln = $offerBox.find('span.price-pl');
    let fullPrice = 0;
    let fullPricePln = 0;

    fullPrice += priceYear;
    fullPricePln += priceYearPln;

    $offerBox.find('.pro-switch-input').each(function (i, obj) {
      if ($(this).is(':checked')) {
        fullPrice += parseFloat($(this).attr('data-price-full'));
        fullPricePln += parseFloat($(this).attr('data-price-full-pln'));
      }
    });
    if (nextYearPrice.length) {
      nextYearPrice.show();
    }
    $priceSpan.text(float_format(fullPrice.toFixed(2)));
    $priceSpanPln.text(float_format(fullPricePln.toFixed(2)));
    // $periodSpan.text(yearString);
  }
}

if ($('.pro-card-box-grid').length) {
  $('.pro-single-switch').on('input', () => {
    setPrice();
  });
}

setPrice();
